import { combineReducers } from 'redux';
import lang from './action/lang';
import page from './action/page';

let reducer = combineReducers({
  lang,
  page,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js